export interface PrerequisiteDefinition {
  title: string;
  text: string;
  url?: string;
}

/**
 * Central registry of template prerequisites, keyed by a stable key.
 *
 * Templates reference these by key via the
 * `equinor.com/template-prerequisites` annotation.
 *
 * To add a prerequisite: add an entry here, then list its key in a template's
 * annotation, e.g. `equinor.com/template-prerequisites: github`.
 */
export const PREREQUISITE_DEFINITIONS: Record<string, PrerequisiteDefinition> = {
  github: {
    title: 'Access to GitHub',
    text: 'Access to at least one Equinor GitHub organization is required. Apply in AccessIT for access to Equinor org (GITHUB) and/or EQ-Playground org (GITHUB), depending on which organization you require.',
    url: 'https://accessit.equinor.com/Search/Search?term=org+github',
  },
  'github-equinor-org': {
    title: 'Access to the Equinor GitHub organization',
    text: 'Access to the Equinor GitHub organization is required. Apply in AccessIT for access to Equinor org (GITHUB).',
    url: 'https://accessit.equinor.com/Search/Search?term=equinor+org+github',
  },
  'github-playground-org': {
    title: 'Access to the Equinor-Playground GitHub organization',
    text: 'Access to the Equinor-Playground GitHub organization is required. Apply in AccessIT for access to EQ-Playground org (GITHUB).',
    url: 'https://accessit.equinor.com/Search/Search?term=eq-playground+org+github',
  },
  radix: {
    title: 'Access to Radix',
    text: 'Access to Radix is required. Apply in AccessIT for access to Radix Platform Users and/or Radix Playground Users, depending on which environment you require.',
    url: 'https://accessit.equinor.com/Search/Search?term=radix+users',
  },
  'github-copilot': {
    title: 'Access to GitHub Copilot',
    text: 'Access to GitHub Copilot is required to get the full effect of this template. Apply in AccessIT for access to GitHub Copilot (GITHUB COPILOT).',
    url: 'https://accessit.equinor.com/Search/Search?term=GitHub+Copilot',
  },
  'azure-admin-key': {
    title: 'Azure admin key (AZ key)',
    text: 'An Azure admin key (AZ user) is required. See the knowledge base article for details on how to request one.',
    url: 'https://equinor.service-now.com/selfservice?id=kb_article&sysparm_article=KB0050631',
  },
  pim: {
    title: 'Elevated Azure admin key (AZ key) using PIM',
    text: 'Your AZ key needs to be elevated using Privileged Identity Management (PIM) in order to perform the requested actions.',
    url: 'https://portal.azure.com/?feature.msaljs=true#view/Microsoft_Azure_PIMCommon/ActivationMenuBlade/~/azurerbac',
  },
};
